import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { Button } from "../ui/button";
import { cn, smoothScroll } from "../../lib/utils";

const navigation = [
  { name: "Home", href: "/" },
  { name: "Servizi", href: "/servizi" },
  { name: "Chi Siamo", href: "/chi-siamo" },
  { name: "Partner", href: "/partner" },
  { name: "Risorse", href: "/risorse" },
  { name: "Contatti", href: "/contatti" },
];

export function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    if (href === "/servizi") {
      e.preventDefault();
      if (location.pathname === "/") {
        smoothScroll("#servizi");
      } else {
        navigate("/", { state: { scrollTo: "servizi" } });
      }
      setIsOpen(false);
    } else {
      setIsOpen(false);
    }
  };

  return (
    <header className="sticky top-0 z-40 w-full border-b bg-white/95 backdrop-blur supports-[backdrop-filter]:bg-white/60">

      <div className="container flex h-20 items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center space-x-2">
          <img src="/Logo_puglialife.webp" alt="Puglia Life - Home Care" className="h-20 w-auto object-contain" />
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-6">
          {navigation.map((item) => (
            <Link
              key={item.name}
              to={item.href}
              onClick={(e) => {
                if (item.href === "/servizi") {
                  handleNavClick(e, item.href);
                }
              }}
              className={cn(
                "text-sm font-medium transition-colors hover:text-brand-primary",
                location.pathname === item.href
                  ? "text-brand-primary font-bold"
                  : "text-text-body"
              )}
            >
              {item.name}
            </Link>
          ))}
          <Button variant="primary" size="sm" asChild>
            <Link to="/contatti">
              <Phone className="mr-2 h-4 w-4" />
              Contattaci
            </Link>
          </Button>
        </nav>

        {/* Mobile Menu Button */}
        <button
          className="flex items-center p-2 md:hidden"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Menu principale"
          aria-expanded={isOpen}
        >
          {isOpen ? (
            <X className="h-6 w-6 text-text-title" />
          ) : (
            <Menu className="h-6 w-6 text-text-title" />
          )}
        </button>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden border-t bg-white">
          <div className="container py-4 flex flex-col space-y-4">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={cn(
                  "text-base font-medium transition-colors hover:text-brand-primary p-2 rounded-md hover:bg-brand-neutral",
                  location.pathname === item.href
                    ? "text-brand-primary bg-brand-neutral"
                    : "text-text-body"
                )}
                onClick={(e) => handleNavClick(e, item.href)}
              >
                {item.name}
              </Link>
            ))}
            <Button className="w-full" asChild>
              <Link to="/contatti" onClick={() => setIsOpen(false)}>
                Contattaci
              </Link>
            </Button>
          </div>
        </div>
      )}
    </header>
  );
}
